import { sharedData } from '../../../models/shared_data'
import React from 'react'

import {
  DialogComponent
} from '../../shared/dialog/dialog.component'

import {
  cityBranchesApi
} from './city_branches_api'

export class CityBranchChooseDialog extends React.Component {
  constructor(props) {
    super(props)
    this.onClose = this.onClose.bind(this)
    this.isActiveCity = this.isActiveCity.bind(this)
    this.choose = this.choose.bind(this)

    sharedData.subject
    .subscribe(()=> {
      this.forceUpdate()
    })
  }
  
  onClose(e) {
    if(sharedData.city_branch) {
      sharedData.toggleCityBranchDialogOpened()
    }
  }

  isActiveCity(cb) {
    if(sharedData.city_branch && cb.id == sharedData.city_branch.id) {
      return 'active'
    }
    return ''
  }

  choose(cb) {
    cityBranchesApi.choose(cb.id).subscribe((d)=> {
      // sharedData.toggleCityBranchDialogOpened()
      window.location.href = '/'
      sharedData.updateData(d.shared_data)
    })
  }

  render() {
    return (
      <DialogComponent opened={sharedData.chooseCityBranchDialogOpened} onClose={this.onClose} height="auto" width="auto">
      <div className="city-box">
        <div className="h4">Выбор города</div>
        <ul className="city-list">
        { sharedData.city_branches.map((city_branch, i) => (
          <li className={this.isActiveCity(city_branch)} key={i} onClick={() => this.choose(city_branch)}>{city_branch.title}</li>
        ))}
        </ul>
        
      </div>
    </DialogComponent>
    )
  }
}

export class CityBranchesButton extends React.Component {
  constructor(props) {
    super(props)
    this.isActive = this.isActive.bind(this)
    this.openDialog = this.openDialog.bind(this)
    sharedData.subject
      .subscribe(()=> {
        this.forceUpdate()
      })
  }

  isActive() {
    return ''
  }

  openDialog(e) {
    e.preventDefault()
    sharedData.chooseCityBranchDialogOpened = true
    sharedData.refresh()
  }

  render() {
    if(!sharedData.data.city_branch) {
      return (
        <div>
          <a href="#" className={this.isActive()}>
            Выбрать город
          </a>
        </div>
      )
    } else {
      return (
        <a href="#" className={this.isActive()} onClick={this.openDialog}>
          {sharedData.data.city_branch.title}
        </a>
      )
    }



  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/city_branches/city_branches_button.component.jsx